import React from "react";
import { Button, Dropdown } from "antd";
import { ReactComponent as LabelIcon } from "../../assets/icon/label.svg"; // Импорт SVG как React-компонент
import useTranslation from "../../hooks/useTranslation";
import { getItemLabelColor, ITEM_LABELS } from "../../constants/itemLabels";

const BookmarkMenu = ({ value = null, onChange, disabled = false }) => {
    const { t } = useTranslation();

    const handleMenuClick = (e) => {
        if (e.key === "clear") {
            onChange?.(null);
        } else {
            const selectedLabel = ITEM_LABELS.find((item) => item.value === e.key);
            if (selectedLabel) {
                onChange?.(selectedLabel.value);
            }
        }
    };

    const selectedColor = getItemLabelColor(value);

    // Пункты данными, а не разметкой: `overlay` и `Menu.Item` в antd v5 объявлены
    // устаревшими, на следующем мажоре их не станет.
    const menuItems = [
        ...ITEM_LABELS.map((item) => ({
            key: item.value,
            icon: <LabelIcon style={{ fill: item.color, width: 16, height: 16 }} />,
            label: t(item.i18nKey),
        })),
        { type: 'divider' },
        { key: 'clear', label: t('labelMenu.clearColor'), style: { textAlign: 'center' } },
    ];

    return (
        <Dropdown menu={{ items: menuItems, onClick: handleMenuClick }} trigger={["click"]}
                  placement="bottomCenter" disabled={disabled}>
            <Button
                type="text"
                disabled={disabled}
                icon={
                    <LabelIcon
                        style={{
                            fill: selectedColor || "#5b5f62", // Цвет иконки меняется в зависимости от выбора
                            width: 24,
                            height: 24,
                        }}
                    />
                }
                onClick={(e) => e.stopPropagation()} // Prevent card click
            />
        </Dropdown>
    );
};

export default BookmarkMenu;
